import './styles/main.scss';
import HeaderBottom from './components/header_bottom';
import Footer from './components/footer'
import MobileLogo from './components/mobileLogo'
import DrawerMobile from './components/drawer';
import classNames from 'classnames';
import * as URL from './router/url';
import theRoutes from './router/router';
import Spinner from './components/spinner';
import React, { Suspense } from 'react';
import { useLocation } from "react-router-dom";

function App() {
  const location = useLocation();
  const { pathname } = location;

  return (
    <div className={classNames("App", { not_main_page: pathname !== URL.ROOT })}>
      <HeaderBottom />
      <MobileLogo />
      <Suspense fallback={<Spinner />}>
        {theRoutes}
      </Suspense>
      <Footer />
      <DrawerMobile />
    </div>
  );
}

export default App;
